import ListUsers from "./list";
import EditUsers from "./edit";

export {ListUsers, EditUsers};
